module.exports = __webpack_public_path__ + "static/alt-two-7cfb983f6deafbc88e9c07ea3c73eabc.mp4";